/**
 * Vanturis collection catalog — mirrors backend `collections` seed.
 *
 * Frontend uses this for:
 *  - Mega-menu navigation
 *  - Early Access form's collection selector
 *  - Coming-soon homepage ordering
 *  - Building preview-page → collection_slug attribution
 *
 * If the backend `collections` collection is edited, prefer to hydrate from
 * `GET /api/collections`; this static list is a design-time fallback and the
 * source of truth for hard-coded routes.
 */
export const COLLECTIONS = [
  {
    slug: "ultra-luxury-motorcoaches",
    name: "Ultra-Luxury Motorcoaches",
    short_label: "Ultra-Luxury",
    tagline: "Prevost. Newell. Marathon.",
    preview_route: "/ultra-luxury-motorcoaches",
    asset_type: "motorcoach",
    order: 10,
    active: true,
  },
  {
    slug: "touring-collection",
    name: "Touring Collection",
    short_label: "Touring",
    tagline: "Coaches built for life on the road.",
    preview_route: "/touring-collection",
    asset_type: "touring_coach",
    order: 20,
    active: true,
  },
  {
    slug: "premium-class-a",
    name: "Premium Class A",
    short_label: "Class A",
    tagline: "Premium American Class A diesel pushers.",
    preview_route: "/premium-class-a",
    asset_type: "class_a",
    order: 30,
    active: true,
  },
  {
    slug: "premium-super-c",
    name: "Premium Super C",
    short_label: "Super C",
    tagline: "Premium Super C motorhomes.",
    preview_route: "/premium-super-c",
    asset_type: "super_c",
    order: 40,
    active: true,
  },
  {
    slug: "overland-vehicles",
    name: "Overland Vehicles",
    short_label: "Overland",
    tagline: "Global-expedition and overland vehicles.",
    preview_route: "/overland-vehicles",
    asset_type: "overland_vehicle",
    order: 50,
    active: true,
  },
  {
    slug: "overland-trailers",
    name: "Overland Trailers",
    short_label: "Overland Trailers",
    tagline: "Off-road expedition trailers.",
    preview_route: "/overland-trailers",
    asset_type: "overland_trailer",
    order: 60,
    active: true,
  },
  {
    slug: "specialty-trailers",
    name: "Specialty Trailers",
    short_label: "Specialty Trailers",
    tagline: "Tour, band and specialty trailers.",
    preview_route: "/specialty-trailers",
    asset_type: "specialty_trailer",
    order: 70,
    active: true,
  },
  {
    slug: "european-collection",
    name: "European Collection",
    short_label: "European",
    tagline: "European luxury motorhomes.",
    preview_route: "/european-collection",
    asset_type: "european_motorhome",
    order: 80,
    active: true,
  },
  {
    slug: "private-aviation",
    name: "Private Jets & Aircraft",
    short_label: "Private Aviation",
    tagline: "Business jets, turboprops and private aircraft.",
    preview_route: "/marketplace/private-aviation",
    asset_type: "private_aviation",
    order: 85,
    active: true,
  },
  {
    slug: "luxury-marine",
    name: "Luxury Boats & Yachts",
    short_label: "Luxury Marine",
    tagline: "Motor yachts, superyachts and luxury vessels.",
    preview_route: "/marketplace/luxury-marine",
    asset_type: "luxury_marine",
    order: 86,
    active: true,
  },
  {
    slug: "auctions",
    name: "Auctions",
    short_label: "Auctions",
    tagline: "Timed and reserve auctions across every collection.",
    preview_route: "/auctions-preview",
    asset_type: "auction",
    order: 90,
    active: true,
  },
];

export const COLLECTION_BY_SLUG = Object.fromEntries(COLLECTIONS.map((c) => [c.slug, c]));

/** Read a stable set of query params from window.location and persist them
 *  once for the whole session so returning submissions share the same UTM. */
export function captureLandingContext() {
  try {
    const KEY = "vanturis_landing_ctx_v1";
    const cached = sessionStorage.getItem(KEY);
    if (cached) return JSON.parse(cached);
    const params = new URLSearchParams(window.location.search);
    const ctx = {
      utm_source: params.get("utm_source") || null,
      utm_medium: params.get("utm_medium") || null,
      utm_campaign: params.get("utm_campaign") || null,
      utm_content: params.get("utm_content") || null,
      utm_term: params.get("utm_term") || null,
      first_landing_page: window.location.pathname || null,
      referral_source: document.referrer || null,
      device_type: /iP(hone|od)|Android.*Mobile|Windows Phone/i.test(navigator.userAgent)
        ? "mobile"
        : /iPad|Android|Tablet/i.test(navigator.userAgent)
        ? "tablet"
        : "desktop",
    };
    sessionStorage.setItem(KEY, JSON.stringify(ctx));
    return ctx;
  } catch (e) {
    return {};
  }
}
